// SWR hooks for report data + filter state + sentiment processing effect.
//
// V-06 fix: the keyphrase endpoint (/v2/survey/:id/sentiment/by_keyphrase)
// is NOT paginated server-side and ignores both ?page and ?sentiment URL
// params. The SWR key therefore omits keyphrasesPage and keyphraseSentiment
// to avoid wasteful refetches when the user pages or filters; both states
// are still consumed client-side by KeyphrasesSection for slicing and
// filtering. See Comprehend.pm:246-299 (survey_sentiment_by_keyphrase).

import { useEffect, useState } from "react";
import useSWR from "swr";

import { fetcherSimple } from "utils/api";

export function useReportsData({ survey, surveyId }) {
    const [keyphraseSentiment, setKeyphraseSentiment] = useState("");
    const [keyphrasesPage, setKeyphrasesPage] = useState(1);
    const [questionTotalSentimentPage, setQuestionTotalSentimentPage] = useState(1);
    const [questionTotalSentimentData, setQuestionTotalSentimentData] = useState({});

    const { data: rawSurveyReport } = useSWR(
        () => survey ? [`/v2/survey/${surveyId}/report/raw`, "GET"] : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    const { data: questionResponsesSentiment } = useSWR(
        () => survey ? [`/v2/survey/${surveyId}/question/sentiment`, "GET"] : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    const { data: questionTotalSentiment } = useSWR(
        () => survey
            ? [`/v2/survey/${surveyId}/questions/sentiment?page=${questionTotalSentimentPage}`, "GET"]
            : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    const { data: sentimentByKeyphrase } = useSWR(
        () => survey
            ? [`/v2/survey/${surveyId}/sentiment/by_keyphrase`, "GET"]
            : null,
        ([path, method]) => fetcherSimple(path, method),
    );

    useEffect(() => {
        if (questionTotalSentiment && questionTotalSentiment.data) {
            const qTotalSent = structuredClone(questionTotalSentiment.data);
            let questionTotalSentimentProcessed = {
                data: [],
                pager: questionTotalSentiment.pager,
            };
            questionTotalSentimentProcessed.data = qTotalSent.map(
                (question) => {
                    let maxValue = 0;
                    const values = Object.values(question.respondent_sentiment || {});
                    maxValue = Math.max(0, ...values);
                    if (question.respondent_sentiment) {
                        question.respondent_sentiment.highest = maxValue;
                    }
                    return question;
                },
            );
            if (questionTotalSentimentProcessed) {
                setQuestionTotalSentimentData(questionTotalSentimentProcessed);
            }
        }
    }, [questionTotalSentiment]);

    return {
        rawSurveyReport,
        questionResponsesSentiment,
        questionTotalSentimentData,
        sentimentByKeyphrase,
        keyphraseSentiment,
        setKeyphraseSentiment,
        keyphrasesPage,
        setKeyphrasesPage,
        questionTotalSentimentPage,
        setQuestionTotalSentimentPage,
    };
}
